// extracted by mini-css-extract-plugin
export default {"component":"page_component__qYFmh","logo":"page_logo__+KXrs","qr":"page_qr__uKKWI","block":"page_block__zIEqk","title":"page_title__DqLLb","text":"page_text__L2AaP"};